<template>
  <div class="login" v-loading="loading">
    <h1>杏林春堂国医馆管理系统</h1>
    <div class="loginbox">
      <div v-if="loginStatus == false">
        <!-- <img @click="type = '1'" v-if="type == '0'" src="@/assets/images/codeScan.jpg" class="icon-img">
        <img @click="type = '0'" v-if="type == '1'" src="@/assets/images/account.jpg" class="icon-img"> -->
        <div class="logintitle">杏林春堂国医馆管理系统登录入口</div>
        <!-- 账号密码登录 -->
        <el-form v-if="type == '1'" class="acc" :model="loginForm">
          <div>
            <span class="iconfont icon-zhanghao"></span>
            <input type="text" v-model.trim="loginForm.username" placeholder="请输入登录账号" />
          </div>
          <div>
            <span class="iconfont icon-ziyuanxhdpi"></span>
            <input type="password" v-model.trim="loginForm.password" placeholder="请输入账号密码" />
          </div>
          <el-button type="primary" @click="login">登 录</el-button>
        </el-form>
        <!-- 微信扫码登录 -->
        <div class="code-warp" v-if="type == '0'">
          <img :src="'data:image/png;base64,' + baseImg" class="code-img">
        </div>
      </div>
    </div>
    <!-- 选择进入查看的医馆 -->
    <div class="loginbox" v-if="loginStatus == true">
      <div class="logintitle">选择相应医馆进入系统</div>
      <Vuescroll class="button">
        <el-button type="primary" plain v-for="item in depts" :key="item.deptId" :value="item.deptId"
          @click="saveDepts(item.deptId)">{{ item.deptName }}</el-button>
      </Vuescroll>
    </div>
    <div class="copyright"><a class="link" href="https://beian.miit.gov.cn/">蜀ICP备19001477号</a> CopyRight © 成都杏林春堂中医门诊部有限公司</div>
  </div>
</template>

<script lang="js">
import { createRoutes } from "@/router";
import { userInfo, checkLogin, routerList, getInQrCode } from "@/api/account"; // 账号请求
import { doctorList } from '@/api/doctor'
import { SystemTime, thresholdValue } from '@/config/systemTime'
import { Utils } from '@/utils/utils'
import { isNull } from "../utils/validateBase";
import { deptDTO } from '@/DTO/index'
export default {
  data() {
    return {
      loginForm: { username: "", password: "" }, // 表单数据双向绑定
      imgUrl: "", // 验证码图片地址
      loginStatus: false, // 选框状态
      options: [], // 医馆选项
      depts: [], // 场馆信息
      loading: false, // 加载状态
      type: '1',//登录方式 0扫码 1账号密码
      baseImg: '',//二维码
      outpatientType:['0','1'],//跳转到门诊的type 医生0，医助1
    };
  },
  async created() {
    let systemTime = SystemTime.getSystemTime()
    SystemTime.correctDiffValue(systemTime)
    let diffValue = Math.abs(this.$session.get('diffValue'))
    if (Utils.gt(diffValue, thresholdValue)) {
      this.$message({
        type: "error",
        message: '检测到电脑时间与当前时间不符，请先设置正确时间',
        duration: 60 * 1000
      })
    }
    // this.getInQrCode()
  },
  methods: {
    // 登录
    async login() {
      this.loading = true
      let { data, code } = await checkLogin(this.loginForm);
      if (code == 200) {
        this.$session.set("t_k", data);
        this.getAccInfo();
      } else {
        this.loading = false
      }
    },
    // 获取用户数据
    async getAccInfo() {
      let { data, code } = await userInfo();
      if (code == 200) {
        this.depts = _.sortBy(data.depts, function (item) { return item.deptId });
        this.$session.set('user', data.user);
        this.$session.set('roles', data.roles);
        this.deptIds();
        // 获取后端返回的路由
        routerList().then(res => {
          if (res.code == 200) {
            // res.data[0].redirect = '/home';
            this.$session.set("menuList", res.data);
            this.loading = false
            this.loginStatus = true;
          } else {
            this.loading = false
          }
        });
      }
    },
    // 生成医馆选项
    deptIds() {
      if (this.depts.length > 0) {
        this.depts.forEach(item => { this.options.push({ label: item.deptName, value: item.deptId }) });
        this.$session.set("options", this.options);
        // let flag = null;
        // if (this.$session.get('user').roles != null) this.$session.get('user').roles.forEach(item => {
        //   if (item.admin == true) flag = true;
        // });
        // if (this.$session.get('roles').includes('admin')) flag = true
        // if (flag == true) this.options.unshift({ label: "总部", value: null });
      }
    },
    // 保存医馆id
    async saveDepts(deptId) {
      let { code, data } = await deptDTO.switchAndGetDept({ deptId: deptId+'' })
      if (code == 200) {
        this.$session.set("deptId", data.deptId);
        this.$session.set("ybDeptNum", data.ybDeptNum);
        this.$session.set("deptInfo", data);
        createRoutes();
        this.$message({
          type: 'success',
          message: '登录成功！',
          duration: '1000'
        })
        let user = this.$session.get('user')
        try {
          if(this.outpatientType.includes(user.type)){
            this.$router.push("/doctorworkstation/newDiagnosis");
          }else{
            this.$router.push("/account/personal");
          }
        } catch (error) {
          this.$router.push("/account/personal");
        }
      }

    },
    // 获取所有医生列表
    async getDoctorList() {
      let { code, rows } = await doctorList()
      if (code == 200) {
        this.$session.set('doctorList', rows)
        this.loading = false
        this.loginStatus = true;
        this.loading = false
        this.loginStatus = true;
      }
    },
    /**
     * 获取登录二维码
     */
    async getInQrCode() {
      let { code, data } = await getInQrCode()
      if (code == 200) {
        this.baseImg = data.baseImg
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: url(../assets/images/login_bg.jpg) center top no-repeat;
  background-size: 100% 100%;

  /* 顶部标题 */
  h1 {
    width: max-content;
    margin: 0 auto;
    padding-top: 50px;
    font-size: 38px;
    letter-spacing: 3px;
    color: #fff;
    text-shadow: 5px 5px 5px #333;
    letter-spacing: 8px;
  }

  /* 登录框 */
  .loginbox {
    width: 500px;
    min-height: 400px;
    background-color: rgba(255, 255, 255, 0.7);
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -240px;
    margin-left: -250px;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 30px 0;

    /* 登录标题 */
    .logintitle {
      width: 360px;
      margin: 0 auto;
      border-bottom: 1px solid #aaa;
      line-height: 40px;
      font-size: 20px;
      font-weight: 500;
      color: #333;
    }

    .icon-img {
      width: 78px;
      height: 78px;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    /* 账号登录 */
    .acc {
      div {
        width: 360px;
        height: 40px;
        line-height: 40px;
        margin: 35px auto;
        display: flex;
        border-radius: 4px;
        background-color: #fff;
        overflow: hidden;

        img {
          margin-right: 10px;
        }

        a {
          color: #333;
        }

        span {
          padding: 0 13px;
          font-size: 18px;
          color: #333;
          background-color: #e6e6e6;
        }

        input {
          flex: 1;
          height: 38px;
          border: none;
          text-indent: 10px;

          &:focus {
            outline: none;
          }
        }
      }

      button {
        display: block;
        line-height: 20px;
        font-size: 18px;
        width: 360px;
        letter-spacing: 10px;
        margin: 0 auto;
      }
    }

    .code-warp {
      width: 300px;
      height: 300px;
      background: #fff;
      margin: 10px auto;
      display: flex;
      align-items: center;
      justify-content: center;

      .code-img {
        width: 250px;
        height: 250px;
      }
    }

    /* 进入医馆按钮样式 */
    .button {
      margin: 30px auto;
      width: 360px !important;
      height: 260px !important;

      .el-button {
        width: 150px;
        margin: 0 0 20px 0;

        &:nth-child(2n) {
          margin-left: 60px;
        }
      }
    }
  }

  /* 版权备案信息 */
  .copyright {
    position: fixed;
    bottom: 10px;
    width: 100%;
    text-align: center;
    line-height: 28px;
    color: #fff;
    font-size: 14px;
  }
  .link{
    font-size: 14px;
    color: #83BEFF;
    text-decoration: underline !important;
    font-style: italic;
  }
}
</style>